/*
 * Baby Doo drawer / modal scroll-lock fix (v3).
 *
 * Symptom: opening a drawer (burger menu OR cart) and then closing it left the
 * page unable to scroll. Cause: the theme locks scrolling by putting `modal-show`
 * / `modal-showing` on <body> (both apply `overflow:hidden`). `modal-showing` is
 * added at the very start of opening and only removed once the open animation
 * finishes (handleAfterShow). When that animation is cut short — a quick
 * open-then-close, or an interrupted transition — handleAfterShow never
 * completes and `modal-showing` stays on <body> forever.
 *
 * v1 no-opped because ModalComponent is not a global.
 * v2 patched ModalComponent.prototype.handleAfterHide (reached through the
 *    registered `drawer-component`) and watched MENU-DRAWER toggles only — so the
 *    cart drawer could still leave the lock stuck.
 * v3 watches every locking element (menu drawer, cart drawer, modals) for its
 *    open/active attribute disappearing, and clears the lock whenever nothing is
 *    genuinely open any more. Scroll stays locked while something IS open.
 */
(function () {
  var LOCKING = 'menu-drawer, cart-drawer, quick-view-modal, basic-modal, modal-component, drawer-component';

  function isOpen(el) {
    return el.hasAttribute('open') || el.hasAttribute('active') || el.open === true;
  }

  function anyLockingOpen() {
    var els = document.querySelectorAll(LOCKING);
    for (var i = 0; i < els.length; i++) {
      if (isOpen(els[i])) return true;
    }
    return false;
  }

  function clearIfNothingOpen() {
    if (!anyLockingOpen()) {
      document.body.classList.remove('modal-show');
      document.body.classList.remove('modal-showing');
    }
  }

  var pending = null;
  function scheduleClear() {
    clearTimeout(pending);
    pending = setTimeout(clearIfNothingOpen, 80);
  }

  /* 1. Patch the close handler so a normal close always re-checks the lock. */
  function patchModalProto() {
    var DrawerComponent = window.customElements && customElements.get('drawer-component');
    if (!DrawerComponent || !DrawerComponent.prototype) return false;

    var modalProto = Object.getPrototypeOf(DrawerComponent.prototype); // ModalComponent.prototype
    if (!modalProto || typeof modalProto.handleAfterHide !== 'function') return false;
    if (modalProto.__bdPatched3) return true;
    modalProto.__bdPatched3 = true;

    var origHide = modalProto.handleAfterHide;
    modalProto.handleAfterHide = function () {
      try {
        origHide.apply(this, arguments);
      } catch (e) {}
      scheduleClear();
    };
    return true;
  }

  /* 2. Safety net: watch open/active attributes on every locking element. */
  function watchAttributes() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType === 1 && t.matches && t.matches(LOCKING) && !isOpen(t)) {
          scheduleClear();
          return;
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'active', 'inert', 'hidden']
    });
  }

  /* 3. Extra nets for closes that bypass the component entirely. */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(LOCKING) && !isOpen(t)) scheduleClear();
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') scheduleClear();
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.drawer__close-btn, .fixed-overlay, [aria-controls]')) scheduleClear();
  }, true);
  window.addEventListener('pageshow', scheduleClear);

  watchAttributes();

  if (!patchModalProto()) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('drawer-component').then(patchModalProto);
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (patchModalProto() || tries > 100) clearInterval(timer);
    }, 50);
  }
})();
